import { IPaging } from '@shared/list-operations/model/paging.model';

interface IListOperationsMetadata {

	storeId: string;

	emitListOperationChanges: boolean;
	useStore: boolean;

	default: {
		paging: IPaging
	};
}

export const LIST_OPERATIONS_METADATA: IListOperationsMetadata = {
	storeId: 'listOperations',
	emitListOperationChanges: true,
	useStore: false,
	default: {
		paging: {
			pageSize: 20,
			pageNumber: 0
		}
	}
};
